module.exports = __webpack_public_path__ + "static/img/xx_pic2.08a76d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rizhi/xx_pic2.jpg
// module id = ERjX
// module chunks = 5